import type { NavItem } from '../types';

export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/safety', icon: 'LayoutDashboard' },
  { label: 'Pre-Job Safety', path: '/safety/jha', icon: 'ClipboardCheck' },
  { label: 'Incidents', path: '/safety/incidents', icon: 'AlertTriangle' },
  { label: 'Corrective Actions', path: '/safety/corrective-actions', icon: 'CheckSquare' },
  { label: 'Documents', path: '/safety/documents', icon: 'FileText' },
  { label: 'Safety Data Sheets', path: '/safety/documents/sds', icon: 'FlaskConical' },
  { label: 'Meetings', path: '/safety/meetings', icon: 'Users' },
  { label: 'Training', path: '/safety/training', icon: 'GraduationCap' },
  { label: 'Compliance', path: '/safety/compliance', icon: 'ClipboardCheck' },
  { label: 'OSHA', path: '/safety/osha', icon: 'ClipboardList' },
];
